import { Role } from 'store/admins';

export const MAINTENANCE = 'MaintenanceAdmin' as Role;
export const ADMIN = 'ClientAdmin' as Role;
export const READ_ONLY_ADMIN = 'ReadOnlyAdmin' as Role;
export const GLOBAL_ADMIN = 'GlobalAdmin' as Role;

export const VALID = 'valid';
export const INVALID = 'invalid';
